module.exports = { 
      attributes: {"title":"Shogi start 2020 with Tesuji's","date":"2020-01-10T00:00:00.000Z","author":"Richi","categories":["news"],"tags":["news"],"language":"en","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("We continue to actively operate Shogi this year.\nFor this, our player Fumihiro did his best and present some Tesuji's from the book\n\"Habu no Housoku 1 Fu KinGin no Tesuji\" selected by the author Habu Yoshiharu.\nTesuji's means getting the most out of a current position.")]),_vm._v(" "),_c('image-reel',[_vm._v("\nErklärung|/praesentation/20200110/2020-01-10.jpg\n")]),_vm._v(" "),_c('p',[_vm._v("In total, Fumihiro introduced us to 6 Tesuji's.\nAfter a relaxed start, the next 4 were quickly resolved.\nOnly at the last one there were almost as many answers as spectators.")]),_vm._v(" "),_c('p',[_vm._v("Many thanks to Fumihiro for making the effort.")])],1) };
            this.$options.staticRenderFns = [];
          }
        }
      },
     }